import React, { useState } from "react";
import { Review } from "@/services/bedrock";
import { SplitView } from "@/components/ui";
import { ReviewPanel, ReviewList } from "@/containers/Players/Reputation/components/ReviewInbox/components";
import { ReviewFiltersProvider } from "./ReviewFiltersContext";

export interface ReviewInboxProps {
  playerId?: number | null;
  onShareReviewLink?: () => void;
}

export function ReviewInbox({ playerId = null, onShareReviewLink }: ReviewInboxProps) {
  const [selectedReview, setSelectedReview] = useState<Review | null>(null);
  const [listState, setListState] = useState({ isLoading: true, reviewsCount: 0 });

  return (
    <ReviewFiltersProvider>
      <div className="flex flex-col select-none flex-1 w-full overflow-hidden min-h-0 px-4 pb-4">
        <SplitView className="flex-1 h-full">
          <ReviewList
            playerId={playerId}
            selectedReview={selectedReview}
            setSelectedReview={setSelectedReview}
            onListStateChange={(isLoading, reviewsCount) => {
              setListState({ isLoading, reviewsCount });
            }}
          />

          <ReviewPanel
            selectedReview={selectedReview}
            isLoading={listState.isLoading}
            reviewsCount={listState.reviewsCount}
            onShareReviewLink={onShareReviewLink}
          />
        </SplitView>
      </div>
    </ReviewFiltersProvider>
  );
}
